import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StatusFieldOption, StatusGroup } from 'api/tasks';

export const EazyStatusSwitchLabel: React.FC<{
  selectedOption: StatusFieldOption | undefined;
}> = ({ selectedOption }) => {
  switch (selectedOption?.group) {
    case StatusGroup.InProgress:
      return (
        <span className="status-label">
          <FormattedMessage id="customer_portal.widgets.project_plan.task_list.status_picker.mark_as_completed" />
        </span>
      );
    case StatusGroup.Completed:
      return <span>{selectedOption?.label}</span>;
    default:
      return (
        <span className="status-label">
          <FormattedMessage id="customer_portal.widgets.project_plan.task_list.status_picker.mark_as_in_progress" />
        </span>
      );
  }

  return <></>;
};
